import { SourceType } from '@api';
import { useQuery } from '@tanstack/react-query';
import { getSubscription } from '@terminal/services/event-alerts/event-alerts-service';

import { QUERY_KEY_EVENT_ALERT_SUBSCRIPTION } from './event-alerts-query-keys';

export const useGetSubscription = (
  sourceId: string,
  sourceType: SourceType,
  enabled = true
) =>
  useQuery({
    queryKey: [QUERY_KEY_EVENT_ALERT_SUBSCRIPTION, sourceId, sourceType],
    queryFn: () => getSubscription(sourceId, sourceType),
    enabled,
  });
